import { Controller } from "@hotwired/stimulus"
import { get } from "@rails/request.js"

// Connects to data-controller="auto-submit"
export default class extends Controller {
  static targets = ['input']

  connect() {
    const back_url = this.element.dataset.backUrl
    const form = this.element
    const input = this.inputTarget

    input.addEventListener('blur', (e) => {
      if (input.value == '') {
        get(`${back_url}.turbo_stream`)
        document.querySelector('#modal-fixed').focus()
      } else {
        form.requestSubmit()
      }
    })
    input.addEventListener('keydown', (e) => {
      e.stopPropagation()
      if (e.keyCode == 13) {
        e.preventDefault()
        input.blur()
        return false
      } else if (e.keyCode == 27) {
        e.preventDefault()
        input.value = ''
        input.blur()
      }
    })
  }
}
